import { Box } from "@mui/material";

import ProspectList from "./ProspectList";

const style = {
  pageContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
} as const;

function ProspectListContainer() {
  return (
    <Box data-testid="prospect-list-container" sx={style.pageContainer}>
      <ProspectList />
    </Box>
  );
}

export default ProspectListContainer;
